import { Sparkles } from "lucide-react";

export const Marquee = ({ items }) => (
  <div className="overflow-hidden border-y border-white/10 bg-night py-5" data-testid="tech-marquee">
    <div className="marquee-track flex w-max items-center gap-10">
      {[...items, ...items].map((item, i) => (
        <span key={i} className="flex items-center gap-10">
          <span className="font-mono text-xs sm:text-sm uppercase tracking-[0.35em] text-slate-500 whitespace-nowrap">
            {item}
          </span>
          <Sparkles className="h-3.5 w-3.5 text-ember/60 shrink-0" />
        </span>
      ))}
    </div>
  </div>
);
